import { combineReducers } from "@reduxjs/toolkit";

import {
	archivesTransactionsDataState,
	archivesTransactionsDataReducer,
	archivesTransactionsDataAction,
} from "./data";

export type StateTransactions = {
	data: archivesTransactionsDataState;
};

export const transactions = combineReducers<StateTransactions>({
	data: archivesTransactionsDataReducer,
});

export const archivesTransactionsAction = {
	data: archivesTransactionsDataAction,
};

export default transactions;
